export enum ComparePeriod {
  Yesterday = 'Yesterday',
  DayBeforeYesterday = 'DayBeforeYesterday',
  Previous7Days = 'Previous7Days',
  Preceding30Days = 'Preceding30Days',
  Previous3Months = 'Previous3Months',
  Previous6Months = 'Previous6Months',
  Previous12Months = 'Previous12Months',
  SamePeriodPreviousWeek = 'SamePeriodPreviousWeek',
  SamePeriodPreviousMonth = 'SamePeriodPreviousMonth',
  SamePeriodPreviousQuarter = 'SamePeriodPreviousQuarter',
  SamePeriodPreviousYear = 'SamePeriodPreviousYear',
  Custom = 'Custom',
}

/*
1. Today -> Default Compare Period: Same day last week
2. Yesterday -> Default Compare Period: The day before yesterday
3. 7D (Last 7 Days) -> Default Compare Period: The previous 7-day period (8-14 days ago)
4. 30D (Last 30 Days) -> Default Compare Period: The preceding 30-day period (31-60 days ago)
5. 3M (Last 3 Months) -> Default Compare Period: The previous 3-month period
6. 6M (Last 6 Months) -> Default Compare Period: The preceding 6-month period
7. 12M (Last 12 Months) -> Default Compare Period: The previous 12-month period (year-over-year comparison)
8. WTD / MTD / QTD / YTD
8.1. Week to Date (WTD): -> Default Compare: Same period in the previous week (e.g., Monday to today vs. the previous Monday to the same weekday).
8.2. Month to Date (MTD): -> Default Compare: Same period in the previous month.
8.3. Quarter to Date (QTD): -> Default Compare: Same period in the previous quarter.
8.4. Year to Date (YTD): -> Default Compare: Same period in the previous year.
9. Custom Time Interval -> Default Compare Period: Matching custom interval in the previous period (e.g., if a user selects Jan 1st - Jan 15th, compare with Dec 17th - Dec 31st, assuming the selected interval was 15 days)
* */
